// Dashboard_content.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

// Icons
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import RoomRoundedIcon from '@mui/icons-material/RoomRounded';
import { FaCrown } from "react-icons/fa";
import FormatPaintRoundedIcon from '@mui/icons-material/FormatPaintRounded';
import ElectricalServicesRoundedIcon from '@mui/icons-material/ElectricalServicesRounded';
import PlumbingRoundedIcon from '@mui/icons-material/PlumbingRounded';
import GridOnRoundedIcon from '@mui/icons-material/GridOnRounded';
import CarpenterRoundedIcon from '@mui/icons-material/CarpenterRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import YardRoundedIcon from '@mui/icons-material/YardRounded';
import WindowRoundedIcon from '@mui/icons-material/WindowRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import CleaningServicesRoundedIcon from '@mui/icons-material/CleaningServicesRounded';
import BathtubRoundedIcon from '@mui/icons-material/BathtubRounded';
import ChairRoundedIcon from '@mui/icons-material/ChairRounded';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import AspectRatioRoundedIcon from '@mui/icons-material/AspectRatioRounded';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded';
import { image, image1, image2 } from './ImageConstants';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
// import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
// ======================================================
// COLORS
// ======================================================
import {
  image3,
  image4,
  image6,
  image5,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
} from './ImageConstants';

// ======================================================
// COLORS
// ======================================================
const PAGE_BG = '#F8F7F4';
const CARD_BG = '#FFFFFF';
const CREAM = '#F3EAD6';
// const BROWN = '#8A6A3D';
const BROWN = '#8A6A3D';

const BROWN_DARK = '#5B4526';
const NEAR_BLACK = '#1E1B16';
const TEXT_BLACK = '#000000';
const TEXT_MUTED = '#6B6350';
const BORDER = 'rgba(138,106,61,0.18)';
const WHITE = '#FFFFFF';

// ======================================================
// CONSTRUCTION ITEMS (5 cards for Rent/PG/Land/Commercial)
// ======================================================
const CONSTRUCTION_ITEMS = [
  {
    title: 'Rent Properties',
    description: 'Find verified rental properties',
    image: require('../../../../src/Images/rent-properties.jpeg'),
    path: '/details',
  },
  {
    title: 'Lease Properties',
    description: 'Residential and commercial properties for lease',
    image: require('../../../../src/Images/lease-properties.jpeg'),
    path: '/lease_details',
  },
  {
    title: 'Plots/Lands',
    description:
      'Residential & Commercial plots for sale',
    image: require('../../../../src/Images/plots-lands.jpeg'),
    path: '/Buy-details',
  },
  {
    title: 'Plots/Houses',
    description:
      'Find Your Perfect Home',
    image: require('../../../../src/Images/plots-houses.jpeg'),
    path: '/Buy-details',
  },
  {
    title: 'Commercial Buildings/Offices',
    description:
      'Offices Spaces & Commercial Buildings',
    image: require('../../../../src/Images/commercial-buildings.jpeg'),
    path: '/lease_details',
  },
   {
    title: 'JV/JD Opportunities',
    description:
      'Joint venture & Joint Development Deals',
    image: require('../../../../src/Images/jvjd.jpeg'),
    path: '/jvjd',
  },
   {
    title: 'Built to Suit(BTS)',
    description:
      'Customized construction for your needs',
    image: require('../../../../src/Images/Built-suit.jpeg'),
    path: '/jvjd',
  }, 
  {
    title: 'Auction Properties',
    description:
      'Bank auction & distributed properties',
    image: require('../../../../src/Images/auction-property.jpeg'),
    path: '/postbank-card',
  },
];

const CATEGORIES = [
  {
    label: 'Buy',
    sub: 'Find Your Dream Home',
    icon: HomeRoundedIcon,
    path: '/buy-property-explorer'
  },
  {
    label: 'Rent',
    sub: 'Find Rental Properties',
    icon: ApartmentRoundedIcon,
    path: '/rent-property-explorer'
  },
  {
    label: 'Lease',
    sub: 'Residential / Commercial',
    icon: BusinessRoundedIcon,
    path: '/lease-property-explorer'
  },
  {
    label: 'JV/JD',
    sub: 'Joint Venture / Development',
    icon: GroupsOutlinedIcon,
    path: '/jvjd-property-explorer'
  },
  {
    label: 'Built to Suit',
    sub: 'Custom Built Properties',
    icon: HomeWorkRoundedIcon,
    path: '/jvjd-property-explorer'
  },
  {
    label: 'Auction Properties',
    sub: 'Value Properties',
    icon: GavelRoundedIcon,
    path: '/auction-property-explorer'
  },
];

const HERO_FEATURES = [
  {
    text: 'Pin to Pin Search',
    icon: LocationOnRoundedIcon,
  },
  {
    text: 'Verified Listings',
    icon: CheckCircleOutlineRoundedIcon,
  },
  {
    text: 'No Middlemen',
    icon: GroupsOutlinedIcon,
  },
  {
    text: 'Smart Matching',
    icon: TrendingUpRoundedIcon,
  },
];

const REQUIREMENT_STEPS = [
  {
    label: 'Location',
    icon: LocationOnOutlinedIcon,
  },
  {
    label: 'Property Type',
    icon: HomeOutlinedIcon,
  },
  {
    label: 'Budget',
    icon: CurrencyRupeeOutlinedIcon,
  },
  {
    label: 'Size',
    icon: AspectRatioOutlinedIcon,
  },
];

const LISTING_STEPS = [
  {
    label: 'Free',
    icon: CheckCircleOutlineRoundedIcon,
  },
  {
    label: 'Premium Listing',
    icon: DiamondOutlinedIcon,
  },
  {
    label: 'Featured Listing',
    icon: StarBorderRoundedIcon,
  },
  {
    label: 'Priority Listing',
    icon: BoltOutlinedIcon,
  },
];
// ======================================================
// NEW WANTED PROPERTIES DATA (Replaces old WANTED_PROPERTIES)
// ======================================================
const NEW_WANTED_PROPERTIES = [
  {
    title: '3 BHK Independent House',
    location: 'Electronic City, Bangalore',
    budget: '₹80 - ₹1.2 Cr',
  },
  {
    title: '1 BHK Studio Apartment',
    location: 'Indiranagar, Bangalore',
    budget: '₹40 - ₹55 Lakh',
  },
];

// ======================================================
// DYNAMIC PROPERTY PERFORMANCE APIs
// ======================================================

const PROPERTY_API_BASE = 'https://landnest.net:81';

const PROPERTY_API_URLS = {
  newLaunch:
    `${PROPERTY_API_BASE}/ad-properties/performance/?displaying_pannels=new_launch_nearest&status=true`,

  premium:
    `${PROPERTY_API_BASE}/ad-properties/performance/?displaying_pannels=premium_nearest&status=true`,

  featured:
    `${PROPERTY_API_BASE}/ad-properties/performance/?displaying_pannels=featured_nearest&status=true`,

  recommended:
    `${PROPERTY_API_BASE}/ad-properties/performance/?displaying_pannels=recommended_nearest&status=true`,
};


// ======================================================
// GET ARRAY FROM API RESPONSE
// ======================================================

const getPropertyArray = (response) => {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.results)) {
    return response.results;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.properties)) {
    return response.properties;
  }

  // In case API returns one property object
  if (response?.property_id) {
    return [response];
  }

  return [];
};


// ======================================================
// IMAGE URL
// ======================================================

const getPropertyImageUrl = (imagePath) => {
  if (!imagePath) {
    return '';
  }

  if (
    imagePath.startsWith('http://') ||
    imagePath.startsWith('https://')
  ) {
    return imagePath;
  }

  return `${PROPERTY_API_BASE}${imagePath}`;
};


// ======================================================
// FIRST HERO IMAGE
// ======================================================

const getFirstHeroImage = (property) => {
  if (
    !Array.isArray(property?.hero_images) ||
    property.hero_images.length === 0
  ) {
    return '';
  }

  const sortedImages = [...property.hero_images].sort(
    (a, b) =>
      Number(a?.order || 0) -
      Number(b?.order || 0)
  );

  return getPropertyImageUrl(
    sortedImages[0]?.image
  );
};


// ======================================================
// CONFIGURATIONS
// ======================================================

const getPropertyConfigurations = (property) => {
  if (!Array.isArray(property?.configurations)) {
    return [];
  }

  return property.configurations;
};


// ======================================================
// MIN PRICE
// ======================================================

const getPropertyMinPrice = (property) => {
  const configurations =
    getPropertyConfigurations(property);

  const prices = configurations
    .map((configuration) =>
      Number(configuration?.price)
    )
    .filter(
      (price) =>
        Number.isFinite(price) &&
        price > 0
    );

  if (prices.length > 0) {
    return Math.min(...prices);
  }

  if (
    property?.price !== null &&
    property?.price !== undefined &&
    property?.price !== ''
  ) {
    const price = Number(property.price);

    if (Number.isFinite(price) && price > 0) {
      return price;
    }
  }

  return null;
};


// ======================================================
// MAX PRICE
// ======================================================

const getPropertyMaxPrice = (property) => {
  const configurations =
    getPropertyConfigurations(property);

  const prices = configurations
    .map((configuration) =>
      Number(configuration?.price)
    )
    .filter(
      (price) =>
        Number.isFinite(price) &&
        price > 0
    );

  if (prices.length > 0) {
    return Math.max(...prices);
  }

  if (
    property?.price !== null &&
    property?.price !== undefined &&
    property?.price !== ''
  ) {
    const price = Number(property.price);

    if (Number.isFinite(price) && price > 0) {
      return price;
    }
  }

  return null;
};


// ======================================================
// FORMAT PRICE
// ======================================================

const formatPropertyPrice = (price) => {
  if (
    price === null ||
    price === undefined ||
    price === ''
  ) {
    return 'Price on Request';
  }

  const numericPrice = Number(price);

  if (
    !Number.isFinite(numericPrice) ||
    numericPrice <= 0
  ) {
    return 'Price on Request';
  }

  // Crores
  if (numericPrice >= 10000000) {
    const crore = numericPrice / 10000000;

    return `₹${Number.isInteger(crore)
      ? crore
      : crore.toFixed(2)
      } Cr`;
  }

  // Lakhs
  if (numericPrice >= 100000) {
    const lakh = numericPrice / 100000;

    return `₹${Number.isInteger(lakh)
      ? lakh
      : lakh.toFixed(2)
      } Lakh`;
  }

  return `₹${new Intl.NumberFormat('en-IN').format(
    numericPrice
  )}`;
};


// ======================================================
// PROPERTY PRICE TEXT
// ======================================================

const shortPrice = (p) => {
  if (p >= 10000000) return `₹${(p / 10000000).toFixed(p % 10000000 === 0 ? 0 : 2)} Cr`;
  if (p >= 100000)   return `₹${(p / 100000).toFixed(p % 100000 === 0 ? 0 : 2)} L`;
  return `₹${p.toLocaleString('en-IN')}`;
};
const getPropertyPriceText = (property) => {
  const minPrice =
    getPropertyMinPrice(property);

  const maxPrice =
    getPropertyMaxPrice(property);

  if (!minPrice && !maxPrice) {
    return 'Price on Request';
  }

  if (
    minPrice &&
    maxPrice &&
    minPrice !== maxPrice
  ) {
    return `${shortPrice(minPrice)} - ${shortPrice(maxPrice)}`;
  }

  return shortPrice(
    minPrice || maxPrice
  );
};


// ======================================================
// BHK TYPES
// ======================================================

const getPropertyBhkTypes = (property) => {
  const configurations =
    getPropertyConfigurations(property);

  const bhks = configurations
    .map(
      (configuration) =>
        configuration?.bhk_type
    )
    .filter(Boolean);

  return [...new Set(bhks)];
};


// ======================================================
// PROPERTY DETAILS
// ======================================================

const getPropertyDetailsText = (property) => {
  const configurations =
    getPropertyConfigurations(property);

  if (configurations.length === 0) {
    return 'Property details available';
  }

  const configuration =
    configurations[0];

  const details = [];

  if (configuration?.bhk_type) {
    details.push(
      configuration.bhk_type
    );
  }

  if (configuration?.carpet_area) {
    details.push(
      `${configuration.carpet_area} Sqft`
    );
  } else if (configuration?.built_up_area) {
    details.push(
      `${configuration.built_up_area} Sqft`
    );
  } else if (
    configuration?.super_built_up_area
  ) {
    details.push(
      `${configuration.super_built_up_area} Sqft`
    );
  }

  if (configuration?.bathrooms) {
    details.push(
      `${configuration.bathrooms} ${Number(configuration.bathrooms) === 1
        ? 'Bath'
        : 'Baths'
      }`
    );
  }

  if (details.length === 0) {
    return 'Property details available';
  }

  return details.join(' • ');
};


// ======================================================
// COMMON PROPERTY DATA
// ======================================================

const getCommonPropertyData = (property) => {
  return {
    ...property,

    id: property?.property_id,

    title:
      property?.property_name ||
      property?.property_type ||
      'Property',

    location:
      property?.address ||
      property?.location ||
      property?.city ||
      'Location unavailable',

    image:
      getFirstHeroImage(property),

    price:
      getPropertyPriceText(property),

    originalProperty:
      property,
  };
};


// ======================================================
// NEW LAUNCH / PREMIUM DATA
// ======================================================

const mapPropertyCardData = (property) => {
  return {
    ...getCommonPropertyData(property),

    suffix: 'Onwards',

    path: `/new-launching-properties/${property?.property_id}`,
  };
};

const mapPremiumPropertyData = (property) => {
  return {
    ...getCommonPropertyData(property),

    suffix: 'Onwards',

    path: `/new-launching-properties/${property?.property_id}`,
  };
};


// ======================================================
// FEATURED DATA
// ======================================================

const mapFeaturedPropertyData = (property) => {
  const configurations =
    getPropertyConfigurations(property);

  const firstConfiguration =
    configurations[0];

  let pricePerSft =
    'Price details available';

  if (
    firstConfiguration?.price &&
    firstConfiguration?.super_built_up_area
  ) {
    const pricePerSqft =
      Number(firstConfiguration.price) /
      Number(
        firstConfiguration.super_built_up_area
      );

    if (Number.isFinite(pricePerSqft)) {
      pricePerSft =
        `₹${Math.round(
          pricePerSqft
        ).toLocaleString('en-IN')} per Sft`;
    }
  }

  return {
    ...getCommonPropertyData(property),

    pricePerSft,

    bhkTypes:
      getPropertyBhkTypes(property),

    path: `/new-launching-properties/${property?.property_id}`,
  };
};


// ======================================================
// RECOMMENDED DATA
// ======================================================

const mapRecommendedPropertyData = (
  property
) => {
  return {
    ...getCommonPropertyData(property),

    details:
      getPropertyDetailsText(property),

    path: `/new-launching-properties/${property?.property_id}`,
  };
};

const QUICK_DEALS_PROPERTIES = [
  {
    title: 'Elite Residency',
    location: 'Koramangala, Bangalore',
    price: '₹3.25 Cr',
    details: '3 BHK • 1850 Sqft • 2 Baths',
    image: require('../../../../src/Images/residencyimage1.png'),
    path: '/new-list'
  },
  {
    title: 'Elite Residency',
    location: 'Koramangala, Bangalore',
    price: '₹3.25 Cr',
    details: '3 BHK • 1850 Sqft • 2 Baths',
    image: require('../../../../src/Images/residencyimage2.png'),
    path: '/new-list'
  },
];
// CONSTRUCTION SERVICES with images
const CONSTRUCTION_SERVICES = [

  {
    title: 'Interiors',
    shortTitle: 'Interiors',
    description: 'Design your dream space',
    icon: HomeRoundedIcon,
    image: image1,
    path: '/interiors'
  },
  {
    title: 'Home Renovation',
    shortTitle: 'Home Renovation',
    description: 'Renovate. Redesign. Reimagine.',
    icon: GavelRoundedIcon,
    image: image2,
    path: '/construction-get-started'
  },
];

// ======================================================
// IMAGES
// ======================================================

const HOME_SERVICES = [
  { title: 'Paintings', image: image3, profession: 'Painting', path: '/home-service-type', icon: FormatPaintRoundedIcon },
  { title: 'Electrical', image: image4, profession: 'Electrical', path: '/home-service-type', icon: ElectricalServicesRoundedIcon },
  { title: 'Plumbing', image: image6, profession: 'Plumbing', path: '/home-service-type', icon: PlumbingRoundedIcon },
  {
    title: 'Tiles & Granite Repair works',
    image: image5,
    profession: 'Tiles & Granite Repair',
    path: '/home-service-type',
    icon: GridOnRoundedIcon,
  },
  { title: 'Carpenter', image: image7, profession: 'Carpenter', path: '/home-service-type', icon: CarpenterRoundedIcon },
  {
    title: 'AC installation',
    image: image8,
    profession: 'AC Technician',
    path: '/home-service-type',
    icon: AcUnitRoundedIcon,
  },
  { title: 'Gardener', image: image9, profession: 'Gardener', path: '/home-service-type', icon: YardRoundedIcon },
  {
    title: 'UPVC Aluminium Fabrication',
    image: image10,
    profession: 'Aluminium Fabrication',
    path: '/home-service-type',
    icon: WindowRoundedIcon,
  },
  {
    title: 'Packings and Movers',
    image: image11,
    profession: 'Packers and Movers',
    path: '/home-service-type',
    icon: LocalShippingRoundedIcon,
  },
  {
    title: 'Gas Pipeline Installation & Repair',
    image: image12,
    profession: 'Gas Pipeline Installation',
    path: '/home-service-type',
    icon: LocalFireDepartmentRoundedIcon,
  },
  {
    title: 'Steel Fabrications',
    image: image13,
    profession: 'Steel Fabrication',
    path: '/home-service-type',
    icon: ConstructionRoundedIcon,
  },
  {
    title: 'Home Clean',
    image: image14,
    profession: 'Home Cleaning',
    path: '/home-service-type',
    icon: CleaningServicesRoundedIcon,
  },
  {
    title: 'Toilet & Kitchen Cleaning',
    image: image15,
    profession: 'Kitchen/Toilet Cleaning',
    path: '/home-service-type',
    icon: BathtubRoundedIcon,
  },
  {
    title: 'Sofa & Curtain Installation & Cleaning',
    image: image16,
    profession: 'Sofa & Curtain Cleaning',
    path: '/home-service-type',
    icon: ChairRoundedIcon,
  },
  {
    title: 'Homemaid',
    image: image17,
    profession: 'Housekeeping',
    path: '/home-service-type',
    icon: CleaningServicesOutlinedIcon,
  },
];

const BANNER_IMAGES = [
  require('../../../../src/Images/banner-new1.png'),
  require('../../../../src/Images/banner-new2.png'),
  require('../../../../src/Images/IMG_3.png'),
  require('../../../../src/Images/banner4.jpeg'),
  require('../../../../src/Images/banner-new5.png'),
];

const CARD_ICONS = {
  postRequirement: require('../../../../src/Images/postpropertyicon.png'),
  listProperty: require('../../../../src/Images/listproperty.png'),
};

const SectionHeader = ({ title, to }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '8px',
        mb: {
          xs: '6px',
          sm: '10px',
        },
      }}
    >
      <Typography
        sx={{
          fontSize: {
            xs: '0.7rem',
            sm: '0.78rem',
          },
          fontWeight: 800,
          letterSpacing: '0.02em',
          color: TEXT_BLACK,
          textTransform: 'uppercase',
          minWidth: 0,
        }}
      >
        {title}
      </Typography>

      <Box
        onClick={() => navigate(to || '#')}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          textDecoration: 'none',
          flexShrink: 0,
          cursor: 'pointer',
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '0.7rem',
              sm: '0.72rem',
            },
            fontWeight: 700,
            color: BROWN,
          }}
        >
          View All
        </Typography>

        <ArrowForwardRoundedIcon
          sx={{
            fontSize: {
              // xs: '0.6rem',
              sm: '0.9rem',
            },
            color: BROWN,
          }}
        />
      </Box>
    </Box>
  );
};



// ======================================================
// CONSTRUCTION PROPERTY CARD (Rent/PG/Land/Commercial)
// ======================================================
const ConstructionPropertyCard = ({ item }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: {
          xs: '10px',
          sm: '16px',
        },
        minWidth: 0,
        cursor: 'pointer',
        background: CARD_BG,
        borderBottom: '1px solid #E5E5E5',
        py: {
          xs: '8px',
          sm: '10px',
        },

        '&:last-child': {
          borderBottom: 'none',
        },

        '&:hover': {
          background: '#F7F0E3',
        },
      }}
    >
      {/* IMAGE */}
      <Box
        component="img"
        src={item.image}
        alt={item.title}
        sx={{
          width: {
            xs: 80,
            sm: 118,
          },
          height: {
            xs: 72,
            sm: 88,
          },
          objectFit: 'cover',
          borderRadius: '3px',
          flexShrink: 0,
        }}
      />

      {/* TEXT */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '0.72rem',
              sm: '1rem',
            },
            fontWeight: 700,
            color: '#1F2D3D',
            lineHeight: 1.2,
            mb: {
              xs: '3px',
              sm: '5px',
            },
          }}
        >
          {item.title}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '0.58rem',
              sm: '0.78rem',
            },
            color: '#8A6A3D',
            lineHeight: 1.35,
            pr: {
              xs: '2px',
              sm: '10px',
            },
          }}
        >
          {item.description}
        </Typography>
      </Box>

      {/* ARROW */}
      <ChevronRightRoundedIcon
        sx={{
          color: '#555555',
          fontSize: {
            xs: '1.3rem',
            sm: '1.8rem',
          },
          flexShrink: 0,
          mr: {
            xs: '3px',
            sm: '8px',
          },
        }}
      />
    </Box>
  );
};

const PropertyCard = ({ p, gradient, tagLabel }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => p.path && navigate(p.path)}
      sx={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        borderRadius: {
          xs: '7px',
          sm: '10px',
        },
        background: CARD_BG,
        border: `1px solid ${BORDER}`,
        overflow: 'hidden',
        boxShadow: '0 4px 14px -6px rgba(46,42,34,0.15)',
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 115,
            sm: 130,
          },
          background: gradient,
        }}
      >
        {p.image ? (
          <Box
            component="img"
            src={p.image}
            alt={p.title}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              background: gradient,
            }}
          />
        )}

        <Box
          sx={{
            position: 'absolute',
            top: {
              xs: 5,
              sm: 10,
            },
            left: {
              xs: 5,
              sm: 10,
            },
            background: 'rgba(0,0,0,0.55)',
            color: WHITE,
            fontSize: {
              xs: '0.45rem',
              sm: '0.62rem',
            },
            fontWeight: 700,
            px: {
              xs: '5px',
              sm: '8px',
            },
            py: {
              xs: '2px',
              sm: '3px',
            },
            borderRadius: '5px',
          }}
        >
          {tagLabel}
        </Box>

        <IconButton
          size="small"
          sx={{
            position: 'absolute',
            top: {
              xs: 3,
              sm: 6,
            },
            right: {
              xs: 3,
              sm: 6,
            },
            background: 'rgba(255,255,255,0.85)',
            width: {
              xs: 22,
              sm: 28,
            },
            height: {
              xs: 22,
              sm: 28,
            },
            '&:hover': {
              background: WHITE,
            },
          }}
        >
          <FavoriteBorderRoundedIcon
            sx={{
              fontSize: {
                xs: '0.8rem',
                sm: '1rem',
              },
              color: BROWN_DARK,
            }}
          />
        </IconButton>
      </Box>

      <Box
        sx={{
          p: {
            xs: '7px',
            sm: '10px 12px',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '0.7rem',
              sm: '0.8rem',
            },
            fontWeight: 700,
            color: TEXT_BLACK,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {p.title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            mt: '2px',
          }}
        >
          <RoomRoundedIcon
            sx={{
              fontSize: {
                xs: '0.65rem',
                sm: '0.85rem',
              },
              color: BROWN,
              flexShrink: 0,
            }}
          />

          <Typography
            sx={{
              fontSize: {
                xs: '0.5rem',
                sm: '0.68rem',
              },
              color: TEXT_MUTED,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {p.location}
          </Typography>
        </Box>

       <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
    mt: {
      xs: '3px',
      sm: '6px',
    },
    minWidth: 0,
    width: '100%',
  }}
>
  <Typography
    sx={{
      fontSize: {
        xs: '0.8rem',
        sm: '0.82rem',
      },
      fontWeight: 600,
      color: BROWN,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: 0,
      flex: 1,
    }}
  >
    {p.price}
  </Typography>

  <Typography
    sx={{
      fontSize: {
        xs: '0.48rem',
        sm: '0.62rem',
      },
      color: BROWN,
      whiteSpace: 'nowrap',
      flexShrink: 0,
    }}
  >
    {p.suffix}
  </Typography>
</Box>
      </Box>
    </Box>
  );
};

const NewWantedCard = ({ p }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate('/property-search')}
      sx={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        gap: {
          xs: '5px',
          sm: '10px',
        },
        background: CARD_BG,
        border: `1px solid ${BORDER}`, // Only regular border, no green left border
        borderRadius: {
          xs: '7px',
          sm: '10px',
        },
        p: {
          xs: '6px',
          sm: '10px',
        },
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Box
        sx={{
          width: {
            sm: 60,
          },
          height: {
            xs: 40,
            sm: 60,
          },
          borderRadius: {
            xs: '6px',
            sm: '10px',
          },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <ApartmentRoundedIcon
          sx={{
            color: '#168A3A', // GREEN icon color
            fontSize: {
              xs: '1.6rem',
              sm: '2.2rem',
            },
          }}
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: {
              xs: '3px',
              sm: '6px',
            },
            minWidth: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '0.6rem',
                sm: '0.78rem',
              },
              fontWeight: 700,
              color: TEXT_BLACK,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              minWidth: 0,
            }}
          >
            {p.title}
          </Typography>

          <Box
            sx={{
              background: '#8A6A3D',
              color: WHITE,
              fontSize: {
                xs: '0.35rem',
                sm: '0.55rem',
              },
              fontWeight: 700,
              px: {
                xs: '3px',
                sm: '6px',
              },
              py: '1px',
              borderRadius: '3px',
              flexShrink: 0,
            }}
          >
            {p.urgency || 'New'}
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: {
              xs: '0.55rem',
              sm: '0.68rem',
            },
            color: TEXT_MUTED,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {p.location}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '0.65rem',
              sm: '0.68rem',
            },
            color: TEXT_BLACK,
            mt: '1px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <b>Budget:</b>{' '}
          <Box
            component="span"
            sx={{ color: '#75542D', fontWeight: 600 }}
          >
            {p.budget}
          </Box>
        </Typography>
      </Box>

      <Typography
        sx={{
          fontSize: {
            xs: '0.4rem',
            sm: '0.62rem',
          },
          color: '#8A6A3D',
          flexShrink: 0,
          fontWeight: 700,
        }}
      >
        {p.tag}
      </Typography>
    </Box>
  );
};

const ActionCard = ({
  title,
  description,
  image,
  steps,
  buttonLabel,
  buttonBg,
  buttonHoverBg,
  path,
  iconColor,
  borderColor,
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',

        background: 'transparent',
border: `1px solid ${borderColor || '#B08A56'}`,

        borderRadius: {
          xs: '8px',
          sm: '12px',
        },

        p: {
          xs: '3px',
          sm: '4%',
        },

        overflow: 'hidden',
      }}
    >
      {/* TITLE */}
      <Typography
        sx={{
          fontSize: {
            xs: '0.6rem',
            sm: '0.72rem',
          },
          fontWeight: 800,
          color: TEXT_BLACK,
          letterSpacing: '0.02em',
          mb: {
            xs: '4px',
            sm: '2%',
          },
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </Typography>

      {/* DESCRIPTION + IMAGE */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: {
            xs: '4px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '5%',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '0.5rem',
              sm: '0.7rem',
            },
            color: TEXT_MUTED,
            flex: 1,
            lineHeight: 1.3,
          }}
        >
          {description}
        </Typography>

        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: {
              xs: 40,
              sm: 64,
            },
            height: {
              xs: 40,
              sm: 64,
            },
            objectFit: 'contain',
            flexShrink: 0,
          }}
        />
      </Box>

      {/* 4 OPTIONS IN ONE ROW */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          gap: {
            xs: '2px',
            sm: '4px',
          },
          mb: {
            xs: '7px',
            sm: '6%',
          },
        }}
      >
        {steps.map(({ label, icon: Icon }) => (
          <Box
            key={label}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: {
                xs: '2px',
                sm: '6px',
              },
              minWidth: 0,

              border: '1px solid #cec6c6',
              borderRadius: {
                xs: '6px',
                sm: '10px',
              },

              background: 'transparent',

              p: {
                xs: '3px 2px',
                sm: '6px 3px',
              },
            }}
          >
            <Icon
              sx={{
                color: iconColor || '#000000',
                fontSize: {
                  xs: '0.7rem',
                  sm: '1rem',
                },
              }}
            />

            <Typography
              sx={{
                fontSize: {
                  xs: '0.4rem',
                  sm: '0.6rem',
                },
                color: TEXT_BLACK,
                textAlign: 'center',
                lineHeight: 1.1,
                wordBreak: 'break-word',
              }}
            >
              {label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* BUTTON */}
      <Button
        fullWidth
        endIcon={
          <ArrowForwardRoundedIcon
            sx={{
              fontSize: {
                // xs: '0.65rem',
                sm: '1rem',
              },
            }}
          />
        }
        onClick={handleButtonClick}
        sx={{
          minWidth: 0,
          background: buttonBg,
          color: WHITE,
          textTransform: 'none',
          fontWeight: 700,
          fontSize: {
            xs: '0.75rem',
            sm: '0.75rem',
          },
          borderRadius: {
            xs: '6px',
            sm: '10px',
          },
          py: {
            xs: '4px',
            sm: '3%',
          },
          px: {
            xs: '4px',
            sm: '8px',
          },

          '& .MuiButton-endIcon': {
            marginLeft: {
              xs: '2px',
              sm: '8px',
            },
          },

          '&:hover': {
            background: buttonHoverBg,
          },
        }}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};
const FeaturedPropertyCard = ({ p }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => p.path && navigate(p.path)}
      sx={{
        width: '100%',
        minWidth: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        overflow: 'hidden',
        borderRadius: {
          xs: '8px',
          sm: '12px',
        },
        background: 'transparent',
        boxSizing: 'border-box',
        minHeight: {
          xs: 145,
          sm: 190,
        },
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      {/* LEFT CONTENT */}
      <Box
        sx={{
          p: {
            xs: '8px',
            sm: '14px',
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minWidth: 0,
          background: '#F7F2EA',
        }}
      >
        <Box>
          {/* PRICE + ICON */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: {
                xs: '5px',
                sm: '10px',
              },
            }}
          >
            <Box
              sx={{
                width: {
                  xs: 30,
                  sm: 46,
                },
                height: {
                  xs: 30,
                  sm: 46,
                },
                borderRadius: '50%',
                background: 'transparent',
                border: '1px solid #000000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <ApartmentRoundedIcon
                sx={{
                  color: '#000000',
                  fontSize: {
                    xs: '1rem',
                    sm: '1.4rem',
                  },
                }}
              />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.7rem',
                    sm: '1rem',
                  },
                  fontWeight: 800,
                  color: BROWN_DARK,
                  whiteSpace: 'nowrap',
                }}
              >
                {p.price}
              </Typography>

              <Typography
                sx={{
                  fontSize: {
                    xs: '0.7rem',
                    sm: '0.65rem',
                  },
                  fontWeight: 700,
                  color: TEXT_BLACK,
                  mt: '2px',
                }}
              >
                {p.pricePerSft}
              </Typography>
            </Box>
          </Box>

          {/* BHK OPTIONS */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: {
                xs: '4px',
                sm: '6px',
              },
              mt: {
                xs: '8px',
                sm: '14px',
              },
            }}
          >
            {(
              p.bhkTypes?.length
                ? p.bhkTypes
                : ['Property']
            ).map((item) => (
              <Box
                key={item}
                sx={{
                  px: {
                    xs: '4px',
                    sm: '6px',
                  },
                  py: {
                    xs: '3px',
                    sm: '5px',
                  },
                  borderRadius: '20px',
                  background: '#cec7c7',
                  border:
                    '1px solid #f0ebe4',
                  fontSize: {
                    xs: '0.5rem',
                    sm: '0.55rem',
                  },
                  fontWeight: 600,
                  color: '#333333',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                {item}
              </Box>
            ))}
          </Box>
        </Box>

        {/* PROPERTY NAME + LOCATION */}
        <Box
          sx={{
            textAlign: 'center',
            mt: '8px',
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '0.7rem',
                sm: '0.9rem',
              },
              fontWeight: 800,
              color: TEXT_BLACK,
            }}
          >
            {p.title}
          </Typography>

          <Typography
            sx={{
              fontSize: {
                xs: '0.6rem',
                sm: '0.65rem',
              },
              fontWeight: 600,
              color: TEXT_BLACK,
              mt: '3px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {p.location}
          </Typography>
        </Box>
      </Box>

      {/* RIGHT IMAGE - FIXED */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          minHeight: {
            xs: 145,
            sm: 190,
          },
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          src={p.image}
          alt={p.title}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </Box>
    </Box>
  );
};

// ======================================================
// RECOMMENDED PROPERTY CARD
// ======================================================

const RecommendedPropertyCard = ({ p }) => {
  const navigate = useNavigate();

  return (
    <Box onClick={() => p.path && navigate(p.path)}
      sx={{
        width: '100%',
        minWidth: 0,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: {
          xs: '8px',
          sm: '12px',
        },
        background: CARD_BG,
        border: `1px solid ${BORDER}`,
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Box
        component="img"
        src={p.image}
        alt={p.title}
        sx={{
          width: '100%',
          height: {
            xs: 190,
            sm: 280,
          },
          objectFit: 'cover',
          display: 'block',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          background: CARD_BG,
          borderRadius: {
            xs: '16px 16px 0 0',
            sm: '22px 22px 0 0',
          },
          p: {
            xs: '8px 10px',
            sm: '14px',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '0.7rem',
              sm: '0.9rem',
            },
            fontWeight: 800,
            color: TEXT_BLACK,
          }}
        >
          {p.title}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '0.45rem',
              sm: '0.65rem',
            },
            color: TEXT_MUTED,
            mt: '2px',
          }}
        >
          {p.location}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '0.7rem',
              sm: '0.75rem',
            },
            fontWeight: 800,
            color: BROWN_DARK,
            mt: '3px',
          }}
        >
          {p.price}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '0.5rem',
              sm: '0.62rem',
            },
            fontWeight: 600,
            color: '#777',
            mt: '2px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {p.details}
        </Typography>
      </Box>
    </Box>
  );
};

const QuickDealPropertyCard = ({ p }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => p.path && navigate(p.path)}
      sx={{
        width: '100%',
        minWidth: 0,
        overflow: 'hidden',
        borderRadius: {
          xs: '8px',
          sm: '10px',
        },
        background: CARD_BG,
        border: `1px solid ${BORDER}`,
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',

        '&:hover': {
          transform: 'scale(1.02)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        },
      }}
    >
      {/* IMAGE */}
      <Box
        component="img"
        src={p.image}
        alt={p.title}
        sx={{
          width: '100%',
          height: {
            xs: 183,
            sm: 240,
          },
          objectFit: 'cover',
          display: 'block',
        }}
      />

      {/* CONTENT - SAME BACKGROUND */}
      <Box
        sx={{
          background: CARD_BG,
          p: {
            xs: '7px 8px 8px',
            sm: '10px 12px',
          },
        }}
      >
        {/* TITLE */}
        <Typography
          sx={{
            fontSize: {
              xs: '0.7rem',
              sm: '0.82rem',
            },
            fontWeight: 800,
            color: TEXT_BLACK,
            lineHeight: 1.2,
          }}
        >
          {p.title}
        </Typography>

        {/* LOCATION */}
        <Typography
          sx={{
            fontSize: {
              xs: '0.5rem',
              sm: '0.65rem',
            },
            color: TEXT_MUTED,
            mt: '2px',
            lineHeight: 1.2,
          }}
        >
          {p.location}
        </Typography>

        {/* PRICE */}
        <Typography
          sx={{
            fontSize: {
              xs: '0.7rem',
              sm: '0.9rem',
            },
            fontWeight: 800,
            color: BROWN_DARK,
            mt: '4px',
            lineHeight: 1.1,
          }}
        >
          {p.price}
        </Typography>

        {/* DETAILS */}
        <Typography
          sx={{
            fontSize: {
              xs: '0.48rem',
              sm: '0.62rem',
            },
            color: '#8A8267',
            mt: '3px',
            lineHeight: 1.2,
          }}
        >
          {p.details}
        </Typography>
      </Box>
    </Box>
  );
};

const ConstructionCard = ({ item }) => {
  const navigate = useNavigate();
  const Icon = item.icon;

  const handleClick = () => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        width: '100%',
        minWidth: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        background: CARD_BG,
        border: `1px solid ${BORDER}`,
        borderRadius: {
          xs: '8px',
          sm: '12px',
        },
        overflow: 'hidden',
        boxSizing: 'border-box',
        minHeight: {
          xs: 100,
          sm: 160,
        },
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      {/* LEFT CONTENT */}
      <Box
        sx={{
          p: {
            xs: '8px',
            sm: '16px',
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minWidth: 0,
          background: '#F7F2EA',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: {
              xs: '7px',
              sm: '12px',
            },
          }}
        >
          <Box
            sx={{
              width: {
                xs: 32,
                sm: 48,
              },
              height: {
                xs: 32,
                sm: 48,
              },
              borderRadius: '50%',
              background: CREAM,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon
              sx={{
                color: BROWN_DARK,
                fontSize: {
                  xs: '1rem',
                  sm: '1.5rem',
                },
              }}
            />
          </Box>

          <Box
            sx={{
              minWidth: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: '0.9rem',
                  sm: '0.82rem',
                },
                fontWeight: 800,
                color: TEXT_BLACK,
                lineHeight: 1.2,
              }}
            >
              {item.shortTitle}
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: '0.6rem',
                  sm: '0.62rem',
                },
                color: TEXT_MUTED,
                mt: '3px',
                lineHeight: 1.3,
              }}
            >
              {item.description}
            </Typography>
          </Box>
        </Box>

        <Button
          endIcon={
            <ArrowForwardRoundedIcon
              sx={{
                fontSize: {
                  // xs: '0.65rem',
                  sm: '1rem',
                },
              }}
            />
          }
          sx={{
            alignSelf: 'center',
            mt: {
              xs: '8px',
              sm: '14px',
            },
            background: NEAR_BLACK,
            color: WHITE,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: {
              xs: '0.55rem',
              sm: '0.68rem',
            },
            height: {
              xs: 22,
              sm: 32,
            },
            px: {
              xs: '6px',
              sm: '12px',
            },
            borderRadius: {
              xs: '4px',
              sm: '7px',
            },
            '& .MuiButton-endIcon': {
              marginLeft: {
                xs: '2px',
                sm: '6px',
              },
            },
            '&:hover': {
              background: '#000',
            },
          }}
        >
          Explore
        </Button>
      </Box>

      {/* RIGHT IMAGE */}
      <Box
        component="img"
        src={item.image}
        alt={item.title}
        sx={{
          width: '100%',
          height: '100%',
          minHeight: {
            xs: 100,
            sm: 160,
          },
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </Box>
  );
};


const HomeServiceCard = ({ item }) => {
  const navigate = useNavigate();
  const Icon = item.icon || HandymanRoundedIcon; // fallback icon if none provided

  const handleClick = () => {
    if (item.path) {
      navigate(item.path, { state: { profession: item.profession } });
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        width: '100%',
        minWidth: 0,
        overflow: 'hidden',
        borderRadius: {
          xs: '10px',
          sm: '12px',
        },
        background: '#F7F2EA', // Changed to match featured properties inner color
        border: `1px solid ${BORDER}`,
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Box
        component="img"
        src={item.image}
        alt={item.title}
        sx={{
          width: '100%',
          height: {
            xs: 62,
            sm: 130,
          },
          objectFit: 'cover',
          display: 'block',
        }}
      />

      <Box
        sx={{
          minHeight: {
            xs: 48,
            sm: 90,
          },
          p: {
            xs: '6px 7px',
            sm: '12px',
          },
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          background: '#F7F2EA', // Added same background for consistency
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Icon
            sx={{
              fontSize: {
                xs: '0.9rem',
                sm: '1.5rem',
              },
              color: '#222',
              flexShrink: 0,
            }}
          />

          <Box
            sx={{
              width: {
                xs: 20,
                sm: 34,
              },
              height: {
                xs: 20,
                sm: 34,
              },
              borderRadius: '50%',
              background: '#A87934',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <ArrowForwardRoundedIcon
              sx={{
                fontSize: {
                  // xs: '0.8rem',
                  sm: '1.3rem',
                },
              }}
            />
          </Box>
        </Box>

        <Typography
          sx={{
            mt: {
              xs: '4px',
              sm: '10px',
            },
            fontSize: {
              xs: '0.52rem',
              sm: '0.9rem',
            },
            fontWeight: 800,
            color: '#222',
            lineHeight: 1.2,
            textAlign: 'left',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {item.title}
        </Typography>
      </Box>
    </Box>
  );
};

// ======================================================
// MAIN DASHBOARD CONTENT
// ======================================================

const Dashboard_content = () => {
  const navigate = useNavigate();

  const [currentSlide, setCurrentSlide] =
    useState(0);

  // ====================================================
  // DYNAMIC PROPERTY STATES
  // ====================================================

  const [
    newLaunchProperties,
    setNewLaunchProperties,
  ] = useState([]);

  const [
    premiumProperties,
    setPremiumProperties,
  ] = useState([]);

  const [
    featuredProperties,
    setFeaturedProperties,
  ] = useState([]);

  const [
    recommendedProperties,
    setRecommendedProperties,
  ] = useState([]);

  const [
    propertiesLoading,
    setPropertiesLoading,
  ] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(
        (prev) => (prev + 1) % BANNER_IMAGES.length
      );
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  // ======================================================
  // FETCH DYNAMIC PROPERTY DATA
  // ======================================================

  useEffect(() => {
    const fetchDashboardProperties =
      async () => {
        try {
          setPropertiesLoading(true);

          const [
            newLaunchResponse,
            premiumResponse,
            featuredResponse,
            recommendedResponse,
          ] = await Promise.all([
            fetch(
              PROPERTY_API_URLS.newLaunch
            ),

            fetch(
              PROPERTY_API_URLS.premium
            ),

            fetch(
              PROPERTY_API_URLS.featured
            ),

            fetch(
              PROPERTY_API_URLS.recommended
            ),
          ]);


          // ==============================================
          // CHECK API RESPONSES
          // ==============================================

          if (!newLaunchResponse.ok) {
            throw new Error(
              `New Launch API failed: ${newLaunchResponse.status}`
            );
          }

          if (!premiumResponse.ok) {
            throw new Error(
              `Premium API failed: ${premiumResponse.status}`
            );
          }

          if (!featuredResponse.ok) {
            throw new Error(
              `Featured API failed: ${featuredResponse.status}`
            );
          }

          if (!recommendedResponse.ok) {
            throw new Error(
              `Recommended API failed: ${recommendedResponse.status}`
            );
          }


          // ==============================================
          // CONVERT RESPONSE TO JSON
          // ==============================================

          const [
            newLaunchData,
            premiumData,
            featuredData,
            recommendedData,
          ] = await Promise.all([
            newLaunchResponse.json(),
            premiumResponse.json(),
            featuredResponse.json(),
            recommendedResponse.json(),
          ]);


          // ==============================================
          // GET PROPERTY ARRAYS
          // ==============================================

          const newLaunchList =
            getPropertyArray(
              newLaunchData
            );

          const premiumList =
            getPropertyArray(
              premiumData
            );

          const featuredList =
            getPropertyArray(
              featuredData
            );

          const recommendedList =
            getPropertyArray(
              recommendedData
            );


          // ==============================================
          // MAP API DATA TO EXISTING UI
          // ==============================================

          setNewLaunchProperties(
            newLaunchList.map(
              mapPropertyCardData
            )
          );

          setPremiumProperties(
            premiumList.map(mapPremiumPropertyData)
          );

          setFeaturedProperties(
            featuredList.map(
              mapFeaturedPropertyData
            )
          );

          setRecommendedProperties(
            recommendedList.map(
              mapRecommendedPropertyData
            )
          );


        } catch (error) {
          console.error(
            'Dashboard property API error:',
            error
          );

          // Clear dynamic data if API fails
          setNewLaunchProperties([]);
          setPremiumProperties([]);
          setFeaturedProperties([]);
          setRecommendedProperties([]);

        } finally {
          setPropertiesLoading(false);
        }
      };


    fetchDashboardProperties();

  }, []);

  const handleCategoryClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        background: PAGE_BG,
        p: {
          xs: '1px 4px',
          sm: '1.5% 2%',
        },
      }}
    >
      {/* ================================================= */}
      {/* HERO BANNER */}
      {/* ================================================= */}

    <Box
  sx={{
    position: 'relative',
    borderRadius: {
      xs: '4px',
      sm: '6px',
    },
    overflow: 'hidden',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    mb: {
      xs: '5px',
      sm: '12px',
    },
    aspectRatio: '40 / 17',
    border: '2px solid #1F1F1F'
  }}
>
        {BANNER_IMAGES.map((img, index) => (
         <Box
  key={index}
  component="img"
  src={img}
  alt={`Property Banner ${index + 1}`}
  sx={{
    width: '100%',
    height: '100%',
    objectFit: 'cover',  
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: currentSlide === index ? 1 : 0,
    transition: 'opacity 0.5s ease-in-out',
  }}
/>
        ))}

        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            // background: 'rgba(0,0,0,0.6)',
            zIndex: 1,
          }}
        />

        {/* <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            p: {
              xs: '4%',
              sm: '3%',
            },
          }}
        >
          <Box
            sx={{
              width: {
                xs: '75%',
                md: '55%',
              },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                color: WHITE,
                fontSize: {
                  xs: '0.7rem',
                  sm: '0.7rem',
                },
                fontWeight: 600,
              }}
            >
              Find Verified Properties
            </Typography>

            <Typography
              sx={{
                color: WHITE,
                fontSize: {
                  xs: '0.75rem',
                  sm: '1.2rem',
                  md: '1.5rem',
                },
                fontWeight: 800,
                mb: '1%',
              }}
            >
              By{' '}
              <Box
                component="span"
                sx={{
                  color: '#D9B76A',
                }}
              >
                PIN Code
              </Box>
            </Typography>

            {HERO_FEATURES.map(({ text, icon: Icon }) => (
              <Box
                key={text}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  mb: '1%',
                }}
              >
                <Icon
                  sx={{
                    fontSize: {
                      xs: '0.55rem',
                      sm: '0.8rem',
                    },
                    color: '#D9B76A',
                  }}
                />

                <Typography
                  sx={{
                    color: WHITE,
                    fontSize: {
                      xs: '0.6rem',
                      sm: '0.6rem',
                    },
                  }}
                >
                  {text}
                </Typography>
              </Box>
            ))}

            <Button
              endIcon={
                <ArrowForwardRoundedIcon
                  sx={{
                    fontSize: {
                      // xs: '0.55rem',
                      sm: '1rem',
                    },
                  }}
                />
              }
              onClick={() => navigate('/buy-map')}
              sx={{
                alignSelf: 'flex-start',
                mt: '2%',
                background: BROWN,
                color: WHITE,
                textTransform: 'none',
                fontWeight: 700,
                fontSize: {
                  xs: '0.5rem',
                  sm: '0.55rem',
                },
                minHeight: {
                  xs: '20px',
                  sm: '30px',
                },
                px: {
                  xs: '6px',
                  sm: '12px',
                },
                py: {
                  xs: '2px',
                  sm: '6px',
                },
                '& .MuiButton-endIcon': {
                  marginLeft: '2px',
                },
                '&:hover': {
                  background: '#75542D',
                },
              }}
            >
              Explore Properties
            </Button>
          </Box>
        </Box> */}

        <Box
          sx={{
            position: 'absolute',
            bottom: '4%',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: {
              xs: '3px',
              sm: '5px',
            },
            zIndex: 3,
          }}
        >
          {BANNER_IMAGES.map((_, i) => (
            <Box
              key={i}
              sx={{
                width: {
                  xs: 3,
                  sm: 5,
                },
                height: {
                  xs: 3,
                  sm: 5,
                },
                borderRadius: '50%',
                background:
                  i === currentSlide
                    ? '#D9B76A'
                    : 'rgba(255,255,255,0.5)',
                cursor: 'pointer',
              }}
              onClick={() => setCurrentSlide(i)}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(3, minmax(0, 1fr))',
            sm: 'repeat(3, minmax(0, 1fr))',
          },
          gap: 0,
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '12px',
            sm: '16px',
          },
          overflow: 'hidden',
          boxSizing: 'border-box',
          mb: {
            xs: '6px',
            sm: '12px',
          },
          minHeight: {
            xs: '80px',
            sm: '120px',
          },
        }}
      >
        {CATEGORIES.map(({ label, sub, icon: Icon, path }) => (
          <Box
            key={label}
            onClick={() => handleCategoryClick(path)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: {
                xs: '4px',
                sm: '9px',
              },
              minWidth: 0,
              cursor: 'pointer',

              p: {
                xs: '7px 5px',
                sm: '14px 18px',
              },

              background: '#EEECE9',

              transition: 'background 0.2s ease',

              '&:hover': {
                background: '#E3E0DB',
              },
            }}
          >
            {/* ICON */}
            <Icon
              sx={{
                color: BROWN,
                fontSize: {
                  xs: '1.8rem',
                  sm: '1.6rem',
                },
                flexShrink: 0,
              }}
            />

            {/* TEXT */}
            <Box
              sx={{
                minWidth: 0,
              }}
            >
              {/* TITLE */}
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.75rem',
                    sm: '0.8rem',
                  },
                  fontWeight: 800,
                  color: TEXT_BLACK,
                  lineHeight: 1.1,
                  whiteSpace:
  ['Auction Properties', 'Built to Suit'].includes(label)
    ? 'normal'
    : 'nowrap',
                }}
              >
                {label}
              </Typography>

              {/* SUBTITLE */}
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.56rem',
                    sm: '0.58rem',
                  },
                  color: '#000',
                  lineHeight: 1.15,
                  mt: {
                    xs: '1px',
                    sm: '2px',
                  },
                  maxWidth: {
                    xs: '100px',
                    sm: '150px',
                  },
                }}
              >
                {sub}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: {
            xs: '5px',
            sm: '12px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
        }}
      >
        <ActionCard
          title="POST YOUR REQUIREMENT"
          titleColor="#BA915B"
          description="Tell us what you are looking for. We will match you for you."
          image={CARD_ICONS.postRequirement}
          steps={REQUIREMENT_STEPS}
          buttonLabel="Post Requirement"
          buttonBg={BROWN}
          buttonHoverBg="#75542D"
          path="/pg-hostel-form"
          iconColor="#000000"
         borderColor="#B08A56" 
        // iconColor="#168A3A"
        />

        <ActionCard
          title="LIST YOUR PROPERTY"
          description="Reach thousands of genuine buyers & tenants"
          image={CARD_ICONS.listProperty}
          steps={LISTING_STEPS}
          buttonLabel="Post Property"
          buttonBg={NEAR_BLACK}
          buttonHoverBg="#000000"
          path="/post"
          iconColor="#000000"
        // iconColor="#E53935"
        />
      </Box>

      {/* ================================================= */}
      {/* NEW WANTED PROPERTIES SECTION (Replaces old Customers Wanted) */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: '1px solid #B08A56',
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: {
              xs: '6px',
              sm: '10px',
            },
          }}
        >
          {/* Left Side */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: {
                xs: '4px',
                sm: '8px',
              },
            }}
          >

            <FaCrown
              style={{
                color: '#E53935',
                fontSize: '1.0rem',
              }}
            />

            <Typography
              sx={{
                fontSize: {
                  xs: '0.7rem',
                  sm: '0.85rem',
                },
                fontWeight: 800,
                color: TEXT_BLACK,
                textTransform: 'uppercase',
              }}
            >
              Customer Wanted Properties
            </Typography>
          </Box>

          {/* Right Side */}
          <Box
            onClick={() => navigate('/property-search')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              cursor: 'pointer',

            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: '0.7rem',
                  sm: '0.7rem',
                   color: '#B56B20',
                    fontWeight: 700,
                },
              }}
            >
              View All
            </Typography>

            <ArrowForwardRoundedIcon
              sx={{
                color: '#B56B20',
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: {
              xs: '5px',
              sm: '8px',
            },
          }}
        >
          {NEW_WANTED_PROPERTIES.map((p, i) => (
            <NewWantedCard key={i} p={p} />
          ))}
        </Box>
      </Box>

      {/* ================================================= */}
      {/* NEW LAUNCHING PROPERTIES */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <SectionHeader
          title="New Launching Properties"
          to="/dashboard/new-launching-props"
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: {
              xs: '5px',
              sm: '8px',
            },
            overflowX: 'auto',
            overflowY: 'hidden',
            scrollBehavior: 'smooth',
            pb: '4px',
            // Optional: hide scrollbar for cleaner look
            '&::-webkit-scrollbar': {
              height: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(138,106,61,0.4)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
          }}
        >
          {newLaunchProperties.map((p, i) => (
            <Box
              key={p.property_id || p.id || i}
              sx={{
                flex: '0 0 auto',
                width: {
                  xs: 'calc(50% - 3px)',
                  sm: 'calc(33.333% - 6px)',
                  md: 'calc(25% - 6px)',
                },
                minWidth: 0,
              }}
            >
              <PropertyCard
                p={p}
                gradient="linear-gradient(135deg,#c9a267 0%,#5b431f 100%)"
                tagLabel="New Launch"
              />
            </Box>
          ))}
        </Box>
      </Box>

      {/* ================================================= */}
      {/* PREMIUM PROPERTIES */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <SectionHeader
          title="Premium Properties"
          to="/dashboard/premium-props"
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: {
              xs: '5px',
              sm: '8px',
            },
            overflowX: 'auto',
            overflowY: 'hidden',
            scrollBehavior: 'smooth',
            pb: '4px',
            '&::-webkit-scrollbar': {
              height: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(138,106,61,0.4)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
          }}
        >
          {premiumProperties.map((p, i) => (
            <Box
              key={p.property_id || p.id || i}
              sx={{
                flex: '0 0 auto',
                width: {
                  xs: 'calc(50% - 3px)',
                  sm: 'calc(33.333% - 6px)',
                  md: 'calc(25% - 6px)',
                },
                minWidth: 0,
              }}
            >
              <PropertyCard
                p={p}
                gradient="linear-gradient(135deg,#8f9b8a 0%,#2c3a30 100%)"
                tagLabel="Premium"
              />
            </Box>
          ))}
        </Box>
      </Box>

    {/* ================================================= */}
{/* FEATURED PROPERTIES */}
{/* ================================================= */}

<Box
  sx={{
    background: CARD_BG,
    border: `1px solid ${BORDER}`,
    borderRadius: {
      xs: '8px',
      sm: '10px',
    },
    p: {
      xs: '6px',
      sm: '10px',
    },
    mt: {
      xs: '6px',
      sm: '12px',
    },
    mb: {
      xs: '6px',
      sm: '12px',
    },
    boxSizing: 'border-box',
  }}
>
  <SectionHeader
    title="Featured Properties"
    to="/dashboard/featured-props"
  />

  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: {
        xs: '8px',
        sm: '10px',
      },
      overflowX: 'auto',
      overflowY: 'hidden',
      scrollBehavior: 'smooth',
      pb: '4px',
      '&::-webkit-scrollbar': {
        height: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(138,106,61,0.4)',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
    }}
  >
    {featuredProperties.map((p, i) => (
      <Box
        key={p.property_id || p.id || i}
        sx={{
          flex: '0 0 auto',
          width: {
            xs: '100%',        // 👈 1 card per view on mobile
            sm: 'calc(50% - 5px)',   // 2 per view on tablet
            md: 'calc(33.333% - 7px)', // 3 per view on desktop
          },
          minWidth: 0,
        }}
      >
        <FeaturedPropertyCard p={p} />
      </Box>
    ))}
  </Box>
</Box>

      {/* ================================================= */}
      {/* RECOMMENDED PROPERTIES */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <SectionHeader
          title="Recommended Properties"
          to="/dashboard/recommended-props"
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: {
              xs: '5px',
              sm: '8px',
            },
            overflowX: 'auto',
            overflowY: 'hidden',
            scrollBehavior: 'smooth',
            pb: '4px',
            '&::-webkit-scrollbar': {
              height: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(138,106,61,0.4)',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
          }}
        >
          {recommendedProperties.map((p, i) => (
            <Box
              key={p.property_id || p.id || i}
              sx={{
                flex: '0 0 auto',
                width: {
                  xs: 'calc(50% - 3px)',
                  sm: 'calc(33.333% - 6px)',
                  md: 'calc(25% - 6px)',
                },
                minWidth: 0,
              }}
            >
              <RecommendedPropertyCard p={p} />
            </Box>
          ))}
        </Box>
      </Box>

      {/* ================================================= */}
      {/* QUICK DEALS PROPERTIES */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: {
              xs: '6px',
              sm: '10px',
            },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '0.7rem',
                sm: '0.78rem',
              },
              fontWeight: 800,
              letterSpacing: '0.02em',
              color: TEXT_BLACK,
              textTransform: 'uppercase',
            }}
          >
            Quick Deals 
          </Typography>

          <Box
            onClick={() => navigate('/new-list')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: '0.7rem',
                  sm: '0.72rem',
                },
                fontWeight: 700,
                color: "#8A6A3D",
              }}
            >
              View All
            </Typography>

            <ArrowForwardRoundedIcon
              sx={{
                fontSize: {
                  // xs: '0.7rem',
                  sm: '0.9rem',
                   color: "#8A6A3D",
                }
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: {
              xs: '5px',
              sm: '8px',
            },
          }}
        >
          {QUICK_DEALS_PROPERTIES.map((p, i) => (
            <QuickDealPropertyCard
              key={i}
              p={p}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          background: CARD_BG,
          border: '1px solid #B08A56',
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '8px',
            sm: '12px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: {
              xs: '4px',
              sm: '6px',
            },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '0.75rem',
                sm: '1rem',
              },
              fontWeight: 800,
              color: '#000000',
            }}
          >
            Properties Explore
          </Typography>


        </Box>

        {/* 5 CARDS */}
        <Box
          sx={{
            width: '100%',
          }}
        >
          {CONSTRUCTION_ITEMS.map((item, index) => (
            <ConstructionPropertyCard
              key={index}
              item={item}
            />
          ))}
        </Box>
      </Box>

      {/* ================================================= */}
      {/* CONSTRUCTION SERVICES */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '6px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <SectionHeader
          title="Construction Services"
          to="/constructions"
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: {
              xs: '5px',
              sm: '10px',
            },
          }}
        >
          {CONSTRUCTION_SERVICES.map((item, index) => (
            <ConstructionCard
              key={index}
              item={item}
            />
          ))}
        </Box>
      </Box>

      {/* ================================================= */}
      {/* HOME SERVICES */}
      {/* ================================================= */}

      <Box
        sx={{
          background: CARD_BG,
          border: `1px solid ${BORDER}`,
          borderRadius: {
            xs: '8px',
            sm: '10px',
          },
          p: {
            xs: '6px',
            sm: '10px',
          },
          mb: {
            xs: '60px',
            sm: '12px',
          },
          boxSizing: 'border-box',
        }}
      >
        <SectionHeader
          title="Home Services"
          to="/home-service"
        />

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: {
              xs: '4px',
              sm: '10px',
            },
            width: '100%',
          }}
        >
          {HOME_SERVICES.map((item) => (
            <HomeServiceCard
              key={item.title}
              item={item}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard_content;